var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#963E97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8266 10.0015L19.9773 10.48C19.8498 10.4959 19.7957 10.6574 19.8865 10.7511L21.0324 11.9334L16.6652 16.4391L14.6981 14.4115C14.5763 14.2859 14.3812 14.2879 14.2614 14.4115L8.04491 20.8272C8.01614 20.8572 8 20.8977 8 20.9399C8 20.982 8.01614 21.0225 8.04491 21.0525L8.91448 21.9536C8.97438 22.0155 9.07293 22.0155 9.13283 21.9536L14.4797 16.4391L16.4449 18.4667C16.5667 18.5903 16.7618 18.5903 16.8816 18.4667L22.1261 13.0598L23.272 14.242C23.2925 14.2631 23.3184 14.2778 23.3466 14.2845C23.3749 14.2912 23.4044 14.2895 23.4317 14.2798C23.4591 14.27 23.4833 14.2525 23.5015 14.2293C23.5197 14.2061 23.5313 14.178 23.5348 14.1483L23.9986 10.1769C24.0121 10.0752 23.9271 9.98751 23.8266 10.0015Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleDevelopment);
export default __webpack_public_path__ + "static/media/peopleDevelopment.033a0e5e06461d1cb16b076a78ffed1c.svg";
export { ForwardRef as ReactComponent };